import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/store";
import { canManageAppointments } from "@/lib/appointments-access";

/** Where somebody who may open appointments, but not administer them, lands instead (AB#842). */
export const APPOINTMENTS_HOME_PATH = "/appointments";

/**
 * Keeps a manage-only appointments page (Availability) to appointments:manage, as the sidebar does
 * (AB#842), so a bookmarked or typed URL sends a view-only user to the Appointments home rather than
 * opening a page they are not offered. Sits inside AppointmentsRoute, which has already turned away
 * anybody without the section, and wraps any page-specific route rather than replacing it.
 */
export function AppointmentsManageRoute({ children }: { children: ReactNode }) {
  // Absent (no slice) reads as no permissions: the route is closed until they are known.
  const permissions = useAppSelector((state) => state.permissions?.permissions ?? []);

  if (!canManageAppointments(permissions)) {
    return <Navigate to={APPOINTMENTS_HOME_PATH} replace />;
  }

  return <>{children}</>;
}
